<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-s-operation"></i>
              工艺管理
            </h1>
            <p class="page-subtitle">管理加工工艺配置，包含工艺图标、名称、类型和描述信息</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加加工工艺" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addButton(null)">新增</el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item>
                <el-input v-model="searchCondition.craft_name" placeholder="请输入加工名称" clearable prefix-icon="el-icon-s-operation">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
        <ApeTable ref="apeTable" :data="dataList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="60" align="center" label="排序">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="拖动排序" placement="top">
                  <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.pid" :data-depth="scope.row.depth">
                    <i class="el-icon-rank"></i>
                  </span>
                </el-tooltip>
              </template>
          </el-table-column>

            <el-table-column width="60" label="序号" align="center">
            <template slot-scope="scope">
                <span class="sequence-number">{{ scope.row.craft_rank }}</span>
            </template>
          </el-table-column>
           
            <el-table-column label="工艺图标" width="100" align="center">
            <template slot-scope="scope">
                <div class="craft-icon">
                  <img 
                    :src="getallUrl(scope.row.craft_icon)" 
                    alt="加工图标" 
                    class="icon-image"
                    @error="handleImageError">
                  <div class="icon-overlay">
                    <i class="el-icon-picture"></i>
                  </div>
                </div>
            </template>
          </el-table-column>
           
            <el-table-column label="工艺信息" min-width="200">
            <template slot-scope="scope">
                <div class="craft-info">
                  <div class="info-row">
                    <i class="el-icon-s-operation"></i>
                    <span class="info-label">工艺名称：</span>
                    <span class="info-value">{{scope.row.craft_name}}</span>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-document"></i>
                    <span class="info-label">文件格式：</span>
                    <el-tag size="mini" type="info">{{scope.row.craft_format}}</el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-setting"></i>
                    <span class="info-label">加工类型：</span>
                    <el-tag :type="getCraftTypeColor(scope.row.craft_type)" size="mini">
                      {{getCraftTypeText(scope.row.craft_type)}}
                    </el-tag>
                  </div>
                  <div class="info-row" v-if="scope.row.craft_desc">
                    <i class="el-icon-document-copy"></i>
                    <span class="info-label">工艺描述：</span>
                    <el-tooltip :content="scope.row.craft_desc" placement="top" :disabled="!scope.row.craft_desc || scope.row.craft_desc.length <= 30">
                      <span class="info-value desc-text">{{scope.row.craft_desc | truncate(30)}}</span>
                    </el-tooltip>
                  </div>
                </div>
            </template>
          </el-table-column>
           
            <el-table-column label="状态" width="120" align="center">
            <template slot-scope="scope">
                <div class="status-switch">
                  <span class="switch-label">{{ scope.row.craft_status === '1' ? '启用状态' : '已禁用状态' }}</span>
                  <el-switch 
                    v-model="scope.row.craft_status" 
                    :active-value="'1'" 
                    :inactive-value="'0'" 
                    active-color="#67c23a" 
                    inactive-color="#f56c6c" 
                    @change="changeStatus(scope.row)">
                  </el-switch>
                </div>
            </template>
          </el-table-column>
           
            <el-table-column v-if="buttonType=='icon'" width="160" label="操作" align="center">
            <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip effect="dark" content="编辑工艺" placement="top">
                    <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="editButton(scope.row.id)"></el-button>
              </el-tooltip>
                  <el-tooltip effect="dark" content="加工分类" placement="top">
                    <el-button size="mini" icon="el-icon-files" circle type="success" @click="getCraftCategory(scope.row.id)"></el-button>
              </el-tooltip>
                </div>
            </template>
          </el-table-column>
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="120px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="加工名称" prop="craft_name">
                <el-input v-model="formData.craft_name" prefix-icon="el-icon-s-operation"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="加工描述" prop="craft_desc">
                <el-input v-model="formData.craft_desc" type="textarea" rows="3" prefix-icon="el-icon-document-copy"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="文件格式" prop="craft_format">
                <el-input v-model="formData.craft_format" prefix-icon="el-icon-document"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="加工类型" prop="craft_type">
                <el-select v-model="formData.craft_type" placeholder="请选择加工类型" style="width: 100%">
                  <el-option label="自动报价" value="1"></el-option>
                  <el-option label="手动报价" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="加工图片" prop="craft_icon">
                <div class="upload-section">
                  <ApeUploader 
                    :limit="1" 
                    @handleUploadSuccess="handleUploadSuccess" 
                    @handleUploadRemove="handleUploadRemove" 
                    :upload-file-list="uploadFileList">
                  </ApeUploader>
                  <div class="upload-tips">
                    <i class="el-icon-info"></i>
                    <span>请上传工艺图标，建议尺寸50x50px，支持JPG、PNG格式</span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <I18nTranslatePanel entity-type="craft" :entity-id="formData.id || ''" />
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import ApeUploader from '@/components/ApeUploader'
import I18nTranslatePanel from '@/components/I18nTranslatePanel'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader,
    I18nTranslatePanel
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        page_size:20,
        current_page:1,
        craft_name:'',
        query:'',
        order_by:'craft_rank asc',
        params:[]
      },
      formItems:[
        {value:'test',
         label:'产品名称',
        },
        {value:'test',
         label:'餐票测试',
        },
        {value:'test',
         label:'产品性能',
        },
      ],
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      // 上传文件列表
      uploadFileList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        current_page:1,
        page_size:20,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      // 表单验证
      rules: {
        craft_name: [{required: true,message:'输入加工名称', trigger: 'blur' }],
        craft_desc: [{required: true,message:'输入加工描述', trigger: 'blur' }],
        craft_type: [{required: true,message:'请选择加工类型', trigger: 'blur' }],
        craft_icon: [{required: true,message:'请上传加工图片', trigger: 'blur' }],
        craft_status: [{required: true,message:'请选择状态', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 获取工艺类型颜色
    getCraftTypeColor(type) {
      return type === '1' ? 'success' : 'warning'
    },
    // 获取工艺类型文本
    getCraftTypeText(type) {
      return type === '1' ? '自动报价' : '手动报价'
    },
    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = 'none'
      event.target.nextElementSibling.style.opacity = '1'
    },
    // 搜索
    searchButton() {
      this.searchCondition.query= ''
      this.searchCondition.params = []

      if (this.searchCondition.craft_name != ''){
        this.searchCondition.query = ' instr(craft_name,?)'
        this.searchCondition.params.push(this.searchCondition.craft_name)
      }
      this.list()
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    // 启用/禁用开关落库
    async changeStatus(row) {
      const prev = row.craft_status === '1' ? '0' : '1'
      const res = await this.$api.post('/service/ola_app_craft/update', row)
      if (this.$apiSuccess(res)) {
        this.$message.success(row.craft_status === '1' ? '已启用' : '已禁用')
      } else {
        row.craft_status = prev
        this.$message.error(res.message || '状态更新失败')
      }
    },
     // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.craft_icon = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.craft_icon = ''
      this.uploadFileList = fileList
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.formData.id = ''
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(加工ID：'+id+')'
      let res = await this.$api.post('/service/ola_app_craft/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
        if (res.data.detail.craft_icon !='' ){
          this.uploadFileList = [{url:res.data.detail.craft_icon}]
        }
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    getallUrl(url){
      if(url==null || url=='' || url==undefined){
        return ''
      }
      let s = String(url).trim()
      if(/^https?:\/\//i.test(s)){
        return s.replace(/(https?:\/\/[^/]+)\/+/i, '$1/')
      }
      const origin = String(window.location.origin || '').replace(/\/+$/, '')
      let path = s.replace(/^\/+/, '/')
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      path = path.replace(/\/+/g, '/')
      return origin + path
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_craft/create'

      if(this.formData.id==''){
        url = '/service/ola_app_craft/create'
      }else{
        url = '/service/ola_app_craft/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.list()
        this.drawerData.visible = false
      }else{
        this.$message.error(res.message)
      }
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      if(row.status=='0'){
        row.status='1'
      }else{
        row.status='0'
      }
      let id = await this.$api.modifyCraft(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteCraft(id)
      if (info == null) {
        this.$message.success('删除成功!')
        this.$nextTick(async () => {
          this.list()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    async getCraftCategory(id) {
       window.open('/craft/'+id+'/category', '_blank');
    },
    // 初始化数据列表
    async list() {
      this.loadingStaus=true
      let obj = Object.assign({},this.searchCondition,this.pagingData)
      let res= await this.$api.post('/service/ola_app_craft/list',obj)
      if (this.$apiSuccess(res)){
        this.dataList=res.data.list
        this.pagingData.total = res.data.page.total
        this.offset = res.data.page.offset
      }
      this.loadingStaus=false
    },
    // 拖拽排序数据提交，请求接口
    async dragSortSubmit(orderIds) {
      let res = await this.$api.post('/service/ola_app_craft/order',{orderIds:orderIds,sort_field:'craft_rank'})
      if (this.$apiSuccess(res)){
        this.$message.success('排序成功!')
        this.list()
      }else{
        this.$message.error('排序失败!')
      }
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el,{
        handle: ".drag-handle", 
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: () => {
          let Ids = []
          let tmp = el.querySelectorAll('.drag-handle')
          for (let i=0,len=tmp.length; i < len; i++) {
            Ids.push(tmp[i].dataset.id)
          }
          this.dragSortSubmit(Ids)
        },
      })
    }
  },
  async mounted() {
    this.list()
    this.$nextTick(() => {
      this.dragSort()
    })
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
    font-size 24px
      font-weight 600
      display flex
      align-items center
    margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.sequence-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 拖拽排序样式
.drag-handle
  font-size 18px
  cursor move
  color #409eff
  
  &:hover
    color #66b1ff

// 工艺图标样式
.craft-icon
  position relative
  display inline-block
  
  .icon-image
    width 50px
    height 50px
    border-radius 8px
    object-fit cover
    border 2px solid #e4e7ed
    transition all 0.3s ease
    
    &:hover
      border-color #409eff
      transform scale(1.05)
  
  .icon-overlay
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
    display flex
    align-items center
    justify-content center
    border-radius 8px
    opacity 0
    transition opacity 0.3s ease
    
    i
      color white
      font-size 20px
  
  &:hover .icon-overlay
    opacity 1

// 工艺信息样式
.craft-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 70px
    
    .info-value
      color #303133
      font-weight 500
      
      &.desc-text
        line-height 1.4

// 状态开关样式
.status-switch
  display flex
  flex-direction column
  align-items center
  gap 6px
  
  .switch-label
    font-size 11px
    color #909399

// 操作按钮样式
.action-buttons
  display flex
  gap 6px
  justify-content center
  
  .el-button.is-circle
    padding 6px
    
    &:hover
      transform translateY(-2px)
      transition all 0.3s ease

// 上传区域样式
.upload-section
  .upload-tips
    display flex
    align-items center
    gap 6px
    margin-top 8px
    padding 8px 12px
    background #f0f9ff
    border-radius 6px
    font-size 12px
    color #409eff
    
    i
      font-size 14px

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px

/deep/ .el-tag
  border-radius 6px
  font-weight 500

/deep/ .el-switch
  .el-switch__core
    border-radius 10px
</style>
